const ProductTemplate = function() {
    function ProductTemplate() {
        this.selector = {
            collapsible: document.getElementById('product-description-collapsible'),
            selling_plan: document.getElementsByName('selling_plan_option'),
            selling_plan_id: document.getElementById('selling-plan-id'),
            atc: document.querySelectorAll('.quatity-add-to-cart-container .add-to-cart'),
            product_price: document.querySelector('.product__price-master')
        }
        this.load()
    }
    ProductTemplate.prototype.load = function() {
        var _ = this;
        if(_.selector.collapsible) {
          _.selector.collapsible.addEventListener('click', event => {
            event.target.closest('.product-description-collapsible').classList.toggle('collapsed');
          })
        }
        if(_.selector.selling_plan.length > 0) {
          _.selector.selling_plan.forEach(plan => {           
            plan.addEventListener('click', event => {
              if(event.target.value === 'one-time-purchase') {
                event.target.closest('.one-time-purchase').classList.add('active');
                event.target.closest('.one-time-purchase').querySelector('label').classList.add('active');
                event.target.closest('.product-selling-plan').querySelector('.subscription').classList.remove('active');
                event.target.closest('.product-selling-plan').querySelector('.subscription > label').classList.remove('active');
                event.target.closest('.product-selling-plan').querySelector('.subscription > input').checked = false;
                let price = event.target.closest('div').querySelectorAll('.group-price > span')[0].textContent;
                _.selector.product_price.textContent = price;
                _.selector.atc.forEach(atc => {
                  atc.textContent = 'Add to cart';
                });
                _.selector.selling_plan_id.value = "";
              } else {
                event.target.closest('.subscription').querySelector('label').classList.add('active');
                event.target.closest('.subscription').classList.add('active');
                event.target.closest('.product-selling-plan').querySelector('.one-time-purchase').classList.remove('active');
                event.target.closest('.product-selling-plan').querySelector('.one-time-purchase > label').classList.remove('active');
                event.target.closest('.product-selling-plan').querySelector('.one-time-purchase > input').checked = false;
                let price = event.target.closest('div').querySelectorAll('.group-price > span')[0].textContent;
                _.selector.product_price.textContent = price;
                _.selector.atc.forEach(atc => {
                  atc.textContent = 'Subscribe now';
                });
                _.selector.selling_plan_id.value = event.target.closest('.product-selling-plan').querySelector('.subscription > input').value;
              }
            })
          })
        }
        const sellingPlanOption = document.getElementById('selling-plan-option-with-subscription');
        if(sellingPlanOption) sellingPlanOption.click();

        _.selector.atc.forEach(function(element) {
          element.addEventListener('click', function() {
            element.classList.add('btn--loading');
            setTimeout(()=> {
              element.classList.remove('btn--loading');
            }, 500)
          })
        })
    }
    ProductTemplate = new ProductTemplate;
}
ProductTemplate();